import React, { ReactElement } from 'react';
import { Toaster } from 'sonner';
import { PopupContext } from "ui-builder";

import './Toast.scss';

/**
 * Toast Context Provider
 * Wraps the application with Sonner's Toaster component configured for bottom-right positioning
 * with dark theme similar to YouTrack's toast notifications.
 */
export function ToastContext(props: { children: ReactElement | ReactElement[] }) {
  return (
    <PopupContext>
      {props.children}
      <Toaster
        position="bottom-right"
        theme="dark"
        duration={5000}
        richColors
      />
    </PopupContext>
  );
}
